import React, { useEffect, useState } from "react";
import { Button, Row, Col, Form, Modal } from "react-bootstrap";
import TablePagination from "@mui/material/TablePagination";
import makeStyles from "@mui/styles/makeStyles";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import HistoricaEfectividadChart from "./HistoricalEfectividadChart";
import AADService from "../../funcionesAuth";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";


const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: "70vh",
    minHeight: "70vh",
    overflowY: "auto",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    //marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: "fit-content",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function ResumenEfectividad() {
  const classes = useStyles();
  const [dataResumenRiesgo, setDataResumenRiesgo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [riesgos, setRiesgos] = useState([]);
  const [historico, setHistorico] = useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();

  const getColor = (index) => {
    const colors = [
      "#00C587",
      "#9F62D2",
      "#01CDEB",
      "#FF803A",
      "#2C2A29",
      "#FFB8D2",
    ];
    return colors[index % colors.length];
  };

  function renderArrowIcon(value_actual, value_simulado) {
    if (value_actual > value_simulado) {
      return <ArrowDownwardIcon style={{ color: "red" }} />;
    } else if (value_actual < value_simulado) {
      return <ArrowUpwardIcon style={{ color: "green" }} />;
    } else {
      return null;
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchDataRiesgo = async () => {
      try {
        setLoading(true);
        const result = await fetch(
          process.env.REACT_APP_API_URL +
          "evaluacion/newcontrolesNew/newresumenefectividad/" +
          localStorage.getItem("idevaluacion") +
          "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (result.ok) {
          const datafetchDataRiesgo = await result.json();
          setDataResumenRiesgo(datafetchDataRiesgo);
        } else {
          console.error("Error en la respuesta del servidor");
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchRiesgosEvaluacion = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "evaluacion/newriesgos/" +
        localStorage.getItem("idevaluacion") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status < 300) {
        let data = await result.json();
        data.sort((a, b) => a.idriesgo - b.idriesgo);
        setRiesgos(data);
      } else {
        setRiesgos([]);
      }
    };

    const fetchHistorico = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "evaluacion/newhistorico/" +
        localStorage.getItem("idevaluacion") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status < 300) {
        let data = await result.json();
        setHistorico(data);
      } else {
        setHistorico([]);
      }
    };

    fetchDataRiesgo();
    fetchRiesgosEvaluacion();
    fetchHistorico();
  }, []);

  const capas =
    dataResumenRiesgo.length > 0
      ? Object.keys(dataResumenRiesgo[0]).filter(
        (key) => key !== "evento_amenaza"
      )
      : [];

  return (
    <div style={{ margin: "20px" }}>
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <Paper>
            <TableContainer
              component={Paper}
              style={{ maxHeight: 600, overflowY: 'auto' }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ backgroundColor: '#2c2a29', color: 'white' }}>
                      Característica
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#2c2a29', color: 'white' }}>
                      ID Riesgo
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#2c2a29', color: 'white' }}>
                      Efectividad de controles sin línea base
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#2c2a29', color: 'white' }}>
                      Efectividad de controles con línea base
                    </TableCell>
                    <TableCell style={{ backgroundColor: '#2c2a29', color: 'white' }}>
                      Diferencia
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {riesgos.map((riesgo, index) => {
                    const efectividad = riesgo?.efectividadcontrol;
                    const base = riesgo?.efectividadcontrol_lb;
                    const diferencia =
                      efectividad != null && base != null
                        ? ((efectividad - base) * 100).toFixed(2)
                        : null;


                    return (
                      <TableRow key={index}>
                        <TableCell>{riesgo?.caracteristica_seguridad || '-'}</TableCell>
                        <TableCell>{riesgo?.idriesgo || '-'}</TableCell>
                        <TableCell>
                          {efectividad != null
                            ? (efectividad * 100).toFixed(2) + '%'
                            : '-'}
                        </TableCell>
                        <TableCell>
                          {base != null ? (base * 100).toFixed(2) + '%' : '-'}
                        </TableCell>
                        <TableCell>
                          {renderArrowIcon(efectividad, base)}
                          {" "}
                          {diferencia != null ? `${Math.abs(diferencia)}%` : '-'}

                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <br />
          <Row>
            <Typography variant="h4" gutterBottom>
              Histórico por Riesgo
            </Typography>
            <HistoricaEfectividadChart
              historicoefectividad={historico ? historico : []}
              getColor={getColor}
            />
          </Row>
          <br />
          <Typography variant="h4" gutterBottom>
            Controles por Amenaza y Capa
          </Typography>
          <Paper className={classes.paper}>
            <TableContainer
              component={Paper}
              style={{ maxHeight: 600, overflowY: "auto" }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ backgroundColor: "#2c2a29", color: "white" }}
                    >
                      Evento de amenaza
                    </TableCell>
                    {capas.map((capa) => (
                      <TableCell
                        key={capa}
                        style={{ backgroundColor: "#2c2a29", color: "white" }}
                      >
                        {capa}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataResumenRiesgo
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.evento_amenaza}</TableCell>
                        {capas.map((capa) => (
                          <TableCell key={capa}>
                            {Array.isArray(row[capa]) &&
                              row[capa].length > 0 ? (
                              <List dense>
                                {row[capa].map((item, idx) => (
                                  <ListItem key={idx} disablePadding>
                                    <ListItemText
                                      primary={`ID: ${item.ID}, Nombre: ${item.Nombre}`}
                                      secondary={
                                        <span
                                          style={{
                                            color:
                                              item.Implementado === "No"
                                                ? "red"
                                                : "inherit",
                                          }}
                                        >
                                          {`Implementado: ${item.Implementado}`}
                                        </span>
                                      }
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </>
      )}
    </div>
  );
}

export default ResumenEfectividad;
